import { render, staticRenderFns } from "./OutOfWarrantyWarningModal.vue?vue&type=template&id=179eaf10&scoped=true&"
import script from "./OutOfWarrantyWarningModal.vue?vue&type=script&lang=js&"
export * from "./OutOfWarrantyWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./OutOfWarrantyWarningModal.vue?vue&type=style&index=0&id=179eaf10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179eaf10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179eaf10')) {
      api.createRecord('179eaf10', component.options)
    } else {
      api.reload('179eaf10', component.options)
    }
    module.hot.accept("./OutOfWarrantyWarningModal.vue?vue&type=template&id=179eaf10&scoped=true&", function () {
      api.rerender('179eaf10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRequest/OutOfWarrantyWarningModal.vue"
export default component.exports